<template>
  <div class="advantage-addition-wrapper">
    <div class="advantage-addition">
      <img src="/static/img/icons/delete.svg" class="delete-icon" @click="deleteAdvantage(advantage.id)"/>
      <b-field>
          <b-input placeholder="Заголовок" v-model="advantage.title" @change="updateAdvantage(advantage)"></b-input>
      </b-field>
      <b-field>
        <b-input placeholder="Текст" type="textarea" v-model="advantage.description" @change="updateAdvantage(advantage)"></b-input>
      </b-field>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'Advantage',
    data () {
      return {
      }
    },
    props: {
      advantage: {
        type: Object,
        required: true
      }
    },
    methods: {
      ...mapActions(['deleteAdvantage', 'updateAdvantage'])
    }
  }
</script>

<style>
.advantage-addition-wrapper {
  background: #eeeeee;
  padding: 30px;
  margin: 20px 0px;
}

.advantage-addition, .service-description {
  max-width: 600px;
  margin: 0 auto;
  position: relative;
}

.delete-icon {
  width: 24px;
  position: absolute;
  top: -20px;
  right: -20px;
  z-index: 100;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// Advantage.vue?6ca939c7